
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["down-arrow",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 49.42 28.52","class":"down-arrow"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cls-1",attrs:{"d":"M24.71 15.16L48.91.86l-24.2 14.3L.51.86"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M24.71 15.16L48.91.86l-24.2 14.3L.51.86"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M24.71 27.36l24.2-14.4-24.2 14.4-24.2-14.4"}})])
          )
        }
      }
    